import instance from '@/services/repository';

const resource = '/customers';

export default {
    get(loadOptions: any) {
        if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
            loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
        }
        return instance.post(`${resource}`, loadOptions);
    },
    getSingle(id: string) {
        return instance.get(`${resource}/${id}`);
    },
};
